import { ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { useObjectContext } from '../hooks/useObjectContext';

interface ObjectFilterBarProps {
  children: ReactNode;
}

export function ObjectFilterBar({ children }: ObjectFilterBarProps) {
  const { regionTargets } = useObjectContext();

  if (!regionTargets.filterBar) {
    return null;
  }

  return createPortal(children, regionTargets.filterBar);
}
